import { PromptChips } from '../prompt-chips/prompt-chips';

interface BizySidePanelSuggestedPromptsProps {
	prompts: string[];
	onSelectPrompt: (prompt: string) => void;
	layout?: 'vertical' | 'horizontal';
}

export function BizySidePanelSuggestedPrompts({ prompts, onSelectPrompt, layout = 'vertical' }: BizySidePanelSuggestedPromptsProps) {
	return <PromptChips prompts={prompts} onSelectPrompt={(prompt) => onSelectPrompt(prompt)} layout={layout} />;
}
